import React from 'react';
export default class Example extends React.Component {
    render() {
        return (<div>
                <div className="badge badge-outline-primary">primary</div>
                <div className="badge badge-outline-alternative">alternative</div>
            </div>);
    }
}
